import axios from 'axios'
import router from '@/router'
import store from '@/store'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    // withCredentials: isToken, //表示跨域请求是否提供凭据信息(cookie、HTTP认证及客户端SSL证明等)
    timeout: 60000 // 请求超时时间
})

//请求拦截
service.interceptors.request.use(config => {
      //为请求头对象添加 token 验证的自定义 Authorization 字段\
      let isToken = store.state.isToken
      if (isToken) {
          config.headers.Authorization = window.sessionStorage.getItem('token')
      }
      //往请求头里添加设备唯一标识
      config.headers.DeviceID = localStorage.getItem('Device-ID')
      return config
  },
  error => {
      console.log(error)
      return Promise.reject(error)
  }
)
// 响应拦截
service.interceptors.response.use(
  response => {
      const res = response.data
      if (res.code !== 0) {
          if (res.code === 50008 || res.code === 50012 || res.code === 50014) {

          }
      } else {
          return res
      }
  },
  error => {
      return Promise.reject(error)
  }
)
export default service
